import React, { useState } from "react";
import ModalWrap from "../../modals/ModalWrap";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import Tab from "@mui/material/Tab";
import "./filter.scss";
import { ageList, genderList } from "../../../utlis/constants";
import closeIcon from "../../../assets/images/closeIcon.svg";

const Filter = ({ showFilter, setShowFilter, userlist }) => {
  const [value, setValue] = useState(0);
  const filterText = ["Age", "Location", "Gender"];
  const locationdata = userlist.map((a) => {
    return a.locationName;
  });
  const finalLocationData = [...new Set(locationdata)];

  const tabHandler = (newValue) => {
    setValue(newValue);
  };

  const closeFilterHandler = () => {
    setShowFilter(false);
  };
  return (
    <ModalWrap
      open={showFilter}
      onClose={closeFilterHandler}
      className="filter-main-wrapper"
    >
      <div className="filter-close-icon-wrapper">
        <img
          src={closeIcon}
          className="close-icon"
          onClick={closeFilterHandler}
        />
      </div>
      <div className="filter-header-wrapper">
        <Typography className="filter-header">Filters</Typography>
        <button className="clear-btn">Clear All</button>
      </div>
      <Box className="tab-box-wrapper">
        <Box className="tab-menu-box">
          <div>
            {filterText.map((item, index) => {
              return (
                <Tab
                  label={item}
                  key={index}
                  onClick={() => tabHandler(index)}
                  className={`tab-menu-item + ${value === index && `selected`}`}
                />
              );
            })}
          </div>
        </Box>
        {value === 0 && (
          <div value="1">
            <FormGroup className="tab-item-wrapper">
              {ageList.map((item) => (
                <FormControlLabel
                  control={<Checkbox />}
                  label={item.title}
                  key={item.value}
                  value={item.value}
                  className={`tab-check-item${
                    ageList.includes(item.value) ? ` selected` : ``
                  }`}
                />
              ))}
            </FormGroup>
          </div>
        )}
        {value === 1 && (
          <div value="2" className="location-list">
            <FormGroup className="tab-item-wrapper location-tab">
              {finalLocationData.map((item) => (
                <FormControlLabel
                  control={<Checkbox />}
                  label={item}
                  key={item}
                  value={item}
                  className={`gender-check-item${
                    genderList.includes(item) ? ` selected` : ``
                  }`}
                />
              ))}
            </FormGroup>
          </div>
        )}
        {value === 2 && (
          <div value="3">
            <FormGroup className="tab-item-wrapper">
              {genderList.map((item) => (
                <FormControlLabel
                  control={<Checkbox />}
                  label={item.title}
                  key={item.value}
                  value={item.value}
                  className={`gender-check-item${
                    genderList.includes(item.value) ? ` selected` : ``
                  }`}
                />
              ))}
            </FormGroup>
          </div>
        )}
      </Box>
      <div className="filter-btn-wrapper">
        <button className="filter-done-btn">Done</button>
      </div>
    </ModalWrap>
  );
};

export default Filter;
